import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AbstractControlState, Boxed, FormControlState, FormGroupState, unbox } from 'ngrx-forms';
import * as R from 'ramda';
import { debounceTime } from 'rxjs/operators';

export const createInputId = (name, id) => `${name}-${id}`;

export type UnaryFn = (arg: any) => any;
export const getControlValue = (control: AbstractControl | AbstractControlState<any>): any => control && control.value;
export const getControls = <T = any>(form: UntypedFormGroup | FormGroupState<T>): any => form && form.controls;
export const getUnboxedControlValue = <T = any>(control: FormControlState<Boxed<T>> | FormGroupState<Boxed<T>>): T => control && R.compose(getControlValue, unbox)(control);
export const getUnboxedFormValue = <B = any, U = any>(form: FormGroupState<B> | AbstractControlState<B>): U => form && R.compose(getControlValue, unbox)(form);

export const isFormControl = R.is(UntypedFormControl);
export const isFormGroup = R.is(UntypedFormGroup);
export const isFormArray = R.is(UntypedFormArray);

/**
 * @return {MonoTypeOperatorFunction<T>} operation function that returns an Observable that delays
 * the emissions of the source Observable by 250 milliseconds.
 */
export const defaultDebounceTime = <T>() => debounceTime<T>(250);
